import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosConfig from '../../utils/axiosConfig';

export const sendChatMessage = createAsyncThunk('chat/send/message', async (message, { rejectWithValue, getState }) => {
	try {

		const response = await axiosConfig.post('/chat/send', {
			message: message,
			from: getState().profile.currentProfile._id,
			to: getState().chat.currentChat.profile
		}, {
			withCredentials: false
		});

		return response.data;
	} catch (error) {
		console.log(error)
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const sendFirstMessage = createAsyncThunk('chat/send/first/message', async ({message, to}, { rejectWithValue, getState }) => {
	try {

		const response = await axiosConfig.post('/chat/send', {
			message: message,
			from: getState().profile.currentProfile._id,
			to: to
		}, {
			withCredentials: false
		});

		return response.data;
	} catch (error) {
		console.log(error)
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const sendSupportMessage = createAsyncThunk('chat/support/send/message', async (message, { rejectWithValue, getState }) => {

	try {
		const response = await axiosConfig.post('/chat/support/send', {
			message: message,
			to: getState().chat.currentChat.profile
		}, {
			withCredentials: false
		});
		
		return response.data;
	} catch (error) {
		console.log(error)
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});
export const deleteChatMessage = createAsyncThunk('chat/delete/message', async (id, { rejectWithValue, getState }) => {
	try {
		const response = await axiosConfig.post('/chat/delete', {
			id: id,
		}, {
			withCredentials: false
		});

		return response.data;
	} catch (error) {
		console.log(error)
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const getChatFiles = createAsyncThunk('chat/files', async (id, { rejectWithValue, getState }) => {
	try {
		let profile = getState().profile.currentProfile._id
		const response = await axiosConfig.post('/chat/files', {
			id: id,
			profile: profile
		}, {
			withCredentials: false
		});

		return response.data;
	} catch (error) {
		console.log(error)
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const sendChatFile = createAsyncThunk('chat/send/file', async (file, { rejectWithValue, getState }) => {
	try {
		let formData = new FormData();
		formData.append("from",  getState().profile.currentProfile._id);
		formData.append("to",  getState().chat.currentChat.profile);
		formData.append("file", file);

		const response = await axiosConfig.post('/chat/file', formData, {
			withCredentials: false,
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		});
		getAdminSupport();
		return response.data;
	} catch (error) {
		console.log(error)
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const getChatMessages = createAsyncThunk('chat/messages', async (id, { rejectWithValue, getState }) => {
	try {
		console.log(getState().profile.currentProfile._id)
		const response = await axiosConfig.post('/chat/messages', {
			id
		});

		return response.data;
	} catch (error) {
		console.log(error)
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const getConversationList = createAsyncThunk('chat/list', async (_, { rejectWithValue, getState }) => {
	try {
		const response = await axiosConfig.post('/chat/list', {
			profile: getState().profile.currentProfile._id,

		});

		return response.data;
	} catch (error) {
		console.log(error)
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const getAdminSupport = createAsyncThunk('chat/admin/list', async (_, { rejectWithValue }) => {
	try {
		const response = await axiosConfig.post('/chat/admin/list', {}, {
			withCredentials: false,
		});

		return response.data;
	} catch (error) {
		return rejectWithValue({
			error: error.response?.data?.message ?? error.message,
		});
	}
});

export const getFullChat = createAsyncThunk('chat/single', async (arg, { rejectWithValue }) => {
	const id = typeof arg === 'string' ? arg : arg?.id;
	const perspectiveProfileId =
		typeof arg === 'object' && arg != null ? arg.perspectiveProfileId : undefined;
	if (!id) {
		return rejectWithValue({ error: 'Missing chat id' });
	}
	try {
		const body = { id };
		if (perspectiveProfileId != null && String(perspectiveProfileId).length > 0) {
			body.perspectiveProfileId = String(perspectiveProfileId);
		}
		const response = await axiosConfig.post('/chat/single', body, {
			withCredentials: false,
		});

		return response.data;
	} catch (error) {
		return rejectWithValue({
			error: error.response?.data?.message ?? error.message,
		});
	}
});

export const goToSupport = createAsyncThunk('chat/support', async (_, { rejectWithValue, getState }) => {
	try {
		const response = await axiosConfig.post('/chat/support', {
			profile: getState().profile.currentProfile._id,
		}, {
			withCredentials: false
		});

		return response.data;
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

/** Admin: all chats for every profile of a user (audit list). */
export const fetchAdminUserChats = createAsyncThunk(
	'chat/admin/user-chats',
	async (userId, { rejectWithValue }) => {
		try {
			const response = await axiosConfig.post(
				'/chat/admin/user-chats',
				{ userId: String(userId) },
				{ withCredentials: false },
			);
			return response.data;
		} catch (error) {
			return rejectWithValue({
				error: error.response?.data?.message ?? error.message,
			});
		}
	},
);

/** Admin: full transcript without marking messages read. */
export const getFullChatAudit = createAsyncThunk(
	'chat/admin/messages',
	async ({ id, perspectiveProfileId }, { rejectWithValue }) => {
		if (!id) {
			return rejectWithValue({ error: 'Missing chat id' });
		}
		try {
			const body = { id: String(id) };
			if (perspectiveProfileId != null && String(perspectiveProfileId).length > 0) {
				body.perspectiveProfileId = String(perspectiveProfileId);
			}
			const response = await axiosConfig.post('/chat/admin/messages', body, {
				withCredentials: false,
			});
			return response.data;
		} catch (error) {
			return rejectWithValue({
				error: error.response?.data?.message ?? error.message,
			});
		}
	},
);
